import React from 'react';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { ActionCreators, LimitKeys } from '../redux';

const LimitFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type Fields = 'limit';
export type Props = {
  type: LimitKeys;
  dirty: boolean;
  limit: number;
  limitConfigurationUpdate: ActionCreators['LimitConfigurationUpdate'];
  name: string;
  submitting: boolean;
  fieldDisabled: (field: Fields) => boolean;
};

const LimitConfiguration: React.FC<Props> = ({
  type,
  fieldDisabled,
  limit,
  limitConfigurationUpdate,
  name,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    limitConfigurationUpdate(type, event.currentTarget.id, parseInt(event.currentTarget.value, 10));
  };

  return (
    <LimitFormInput
      id='limit'
      type='text'
      label={`${name} Limit`}
      onChange={handleChange}
      readonly={fieldDisabled('limit')}
      value={limit}
      required={true}
    />
  );
};

export { LimitConfiguration };
